import { IIndexable } from '../model/IIndexable';
import { Phone } from '../model/Phone';

export function phoneMapping(item: IIndexable) {
  return new Phone(item.prefix, item.telephone);
}
